// extracted by mini-css-extract-plugin
export default {"chart":"iho-or-cho-chart_chart__pnvr1","rate":"iho-or-cho-chart_rate__h+dZr"};